// prettier-ignore
const rules = [
  // Permissions defined by current user's roles in AD

  //The '*' character can be used as a wildcard for any length of string in the 'role' field.
  //Multiple '*' characters can be used in a single wildcard role.
  //Make sure the wildcard does not allow roles to access resources they should not have access to.
  //Detailed explanation about usage and purpose can be found in a related Confluence page
  //https://bareinternational.atlassian.net/wiki/spaces/CAS/pages/597983233/Azure+Roles+with+Wildcards

  { role: 'ApolloShopCopier', type: 'submenu,ButtonRowButton', item: 'apolloshopcopier' },
  { role: 'AssignmentView', type: 'faicon', item: 'assignment_viewdetail' },
  { role: 'AssignmentView', type: 'submenu', item: 'operations_assignments' },
  { role: 'ClientContacts', type: 'submenu', item: 'sales_clientcontacts' },
  {
    role: 'UserAdmin',
    type: 'menu,submenu,ButtonRowButton,faicon,inputfield,actionbutton,tablisttable,detailBox',
    item: 'useradmin_EditUser',
  },
  {
    role: 'ClientView,ClientEdit,ClientCreateAdmin,KAMGuest,KAM,KAMAdmin,SalesAdmin,Sales,SalesGuest,OpportunityView',
    type: 'menu,submenu',
    item: 'sales',
  },
  {
    role: 'ClientView,ClientEdit,ClientCreateAdmin,KAMGuest,KAM,KAMAdmin,SalesAdmin,Sales,SalesGuest',
    type: 'submenu',
    item: 'sales_clients',
  },
  { role: 'ClientCreateAdmin,SalesAdmin', type: 'ButtonRowButton', item: 'Client_ButtonRowButton_Create' },
  { role: 'ClientView,KAM,KAMAdmin,KAMGuest,Sales,SalesAdmin', type: 'submenu', item: 'operations_location' },
  { role: 'CreditMemoAssigneeChange', type: 'inputfield', item: 'creditmemo_editassignee' },
  //{ role: 'CreditMemoAssigneeChange,CreditMemoEdit', type: 'actionbutton', item: 'creditmemo_editactionbutton' },
  { role: 'CreditMemoAssigneeChange,CreditMemoEdit', type: 'ButtonRowButton', item: 'creditmemo_editbuttonrowbutton' },
  {
    role: 'CreditMemoAssigneeChange,OfficeAdmin,CreditMemoEdit',
    type: 'faicon,tablisttable',
    item: 'creditmemo_editfaicon',
  },
  // {
  //   role: 'CreditMemoAssigneeChange,OfficeAdmin,CreditMemoEdit',
  //   type: 'faicon',
  //   item: 'creditmemo_statuschangefaicon',
  // },
  { role: 'CreditMemoView', type: 'submenu', item: 'operations_creditmemos' },
  { role: 'enable_user_past_timesheetentries', type: 'faicon', item: 'useradmin_enable_user_past_timesheetentries' },
  { role: 'EvaluatorAssignmentsButton', type: 'faicon', item: 'Evaulator_faicon_AssignmentsButton' },
  { role: 'EvaluatorEdit', type: 'faicon', item: 'Evaulator_faicon_Edit' },
  { role: 'EvaluatorESPView', type: 'tablisttable', item: 'Evaulator_tablisttable_EvaluatorESPView' },
  { role: 'EvaluatorExport', type: 'submenu', item: 'evaluator_export' },
  { role: 'EvaluatorGeneralView', type: 'detailBox', item: 'Evaulator_detailBox_EvaluatorGeneralView' },
  { role: 'EvaluatorGeneralView', type: 'tablisttable', item: 'Evaulator_tablisttable_EvaluatorGeneralView' },
  {
    role: 'Admin,AntiFraudToolView,AntiFraudToolEdit',
    type: 'tablisttable',
    item: 'Evaulator_tablisttable_EvaluatorFraudView',
  },
  { role: 'EvaluatorListView,EvaluatorGeneralView', type: 'submenu', item: 'evaluator_admin' },
  { role: 'AntiFraudToolView,AntiFraudToolEdit', type: 'submenu', item: 'operations_antifraudtool' },
  { role: 'AntiFraudToolView,AntiFraudToolEdit', type: 'submenu', item: 'fraudhitdetails' },
  { role: 'AntiFraudToolEdit', type: 'faicon', item: 'AntiFraudTool_ActionButton' },
  {
    role: 'EvaluatorPaymentDetailsView',
    type: 'tablisttable',
    item: 'Evaulator_tablisttable_EvaluatorPaymentDetailsView',
  },
  { role: 'EvaluatorPaymentEdit', type: 'faicon', item: 'EvaluatorPayment_ActionButton' },
  { role: 'EvaluatorPaymentAssigneeChange', type: 'faicon', item: 'EvaluatorPayment_ActionButton' },
  {
    role: 'EvaluatorPaymentEdit,EvaluatorPaymentView',
    type: 'ButtonRowButton',
    item: 'EvaluatorPayment_ResendStatement_FigmaButtonRowButton',
  },
  {
    role: 'EvaluatorPaymentEdit,Finance,FinanceAdmin',
    type: 'ButtonRowButton',
    item: 'EvaluatorPayment_FigmaButtonRowButton',
  },
  // Generate Assignment Payment on both Excluded PS tabs (Assignment Payments and TP Evaluator TP Job Payments) — the
  // same AD roles /api/ClientInvoice/GenerateAssignmentPayment and /api/TpEvaluatorTpJobPayment/GenerateAssignmentPayment
  // require. Under the payment key above, Finance users got the button and a 403 (EPEA56).
  {
    role: 'Admin,ProjectEdit',
    type: 'ButtonRowButton',
    item: 'EvaluatorPayment_GenerateAssignmentPayment_FigmaButtonRowButton',
  },
  {
    role: 'AdvancePaymentCreate',
    type: 'ButtonRowButton',
    item: 'EvaluatorPayment_NewAdvancePaymentButton',
  },
  {
    role: 'EvaluatorPaymentsButton,EvaluatorPaymentView',
    type: 'faicon',
    item: 'Evaulator_faicon_EvaluatorPaymentsButton',
  },
  {
    role: 'EvaluatorPaymentView,EvaluatorPaymentEdit,Finance,FinanceAdmin',
    type: 'submenu',
    item: 'operations_paymentexports',
  },
  {
    role: 'EvaluatorPaymentView,EvaluatorPaymentEdit,Finance,FinanceAdmin',
    type: 'submenu',
    item: 'operations_evaluatorpayments',
  },
  {
    role: 'EvaluatorPaymentView,Finance,FinanceAdmin',
    type: 'faicon',
    item: 'EvaluatorPayment_ResendStatement_ActionButton',
  },
  { role: 'EvaluatorPaymentAssigneeChange', type: 'inputfield', item: 'evaluatorpayment_editassignee' },
  { role: 'EvaluatorTipaltiProfileButton', type: 'faicon', item: 'Evaulator_faicon_EvaluatorTipaltiProfileButton' },
  // TP Evaluator linking (Link button in the Linked TP Evaluators tab, Detach row action) — same AD role the
  // backend endpoints require.
  { role: 'Evaluator', type: 'faicon', item: 'Evaulator_faicon_PrimaryLinkButton' },
  { role: 'Evaluator', type: 'ButtonRowButton', item: 'Evaulator_ButtonRowButton_PrimaryLink' },
  { role: 'Finance,FinanceAdmin', type: 'faicon', item: 'ExportPayment_ActionButton' },
  { role: 'Finance,FinanceAdmin', type: 'ButtonRowButton', item: 'ExportPayment_FigmaButtonRowButton' },
  { role: 'Finance,FinanceAdmin', type: 'faicon', item: 'ExportPaymentActionButtons' },
  { role: 'Finance,FinanceAdmin', type: 'tablisttable', item: 'office_edc_ohdc' },
  { role: 'Finance,FinanceAdmin,FinanceGuest,OfficeAdmin', type: 'tablisttable', item: 'home_offices_tax' },
  { role: 'Finance,FinanceAdmin,OfficeAdmin,OfficeAdminWrite', type: 'tablisttable', item: 'home_offices_corp' },
  { role: 'Finance,FinanceAdmin,OfficeAdmin,OfficeAdminWrite', type: 'tablisttable', item: 'home_offices_emp' },
  { role: 'Finance,FinanceAdmin,OfficeAdmin,OfficeAdminWrite', type: 'tablisttable', item: 'home_offices_video' },
  { role: 'Finance,FinanceAdmin,OfficeOverhead', type: 'faicon', item: 'office_overhead_edit' },
  { role: 'FinanceReportsSSRS', type: 'submenu', item: 'finance_reports' },

  { role: 'Finance*_VendorMgtm,VendorInvoicingAdmin_*', type: 'submenu,link', item: 'freelancer_paymentexports' },
  {
    role: 'Finance*_VendorMgtm,VendorInvoicing_*,VendorInvoicingAdmin_*',
    type: 'faicon,ButtonRowButton',
    item: 'FreelancerUser_EditAction',
  },
  {
    role: 'FinanceAdmin_VendorMgtm,VendorInvoicingAdmin_*',
    type: 'inputfield',
    item: 'Freelancer_inputfield_VendorAdminFinanceAdmin',
  },
  { role: 'Finance*_VendorMgtm,VendorInvoicing_*,VendorInvoicingAdmin_*', type: 'menu,submenu', item: 'freelancer' },
  {
    role: 'Finance*_VendorMgtm,VendorInvoicing_RM,VendorInvoicing_DQ,VendorInvoicingAdmin_DQ,VendorInvoicingAdmin_RM',
    type: 'menu,submenu',
    item: 'freelancerpayableassignment',
  },
  {
    role: 'VendorInvoicing_*,VendorInvoicingAdmin_*',
    type: 'datatable,ButtonRowButton,faicon',
    item: 'freelancerdatatable_action',
  },
  { role: 'Finance*_VendorMgtm,VendorInvoicing*_RM', type: 'faicon', item: 'isactive_rm_ignoredsurvey' },
  { role: 'Finance*_VendorMgtm,VendorInvoicing*_DQ', type: 'faicon', item: 'isactive_dq_ignoredsurvey' },
  //{ role: 'Admin', type: 'faicon', item: 'freelancer_evaluatorsassieid_admin' },
  { role: 'VendorInvoiceDownload', type: 'ButtonRowButton', item: 'freelancerinvoice_exportattachments' },
  { role: 'VendorInvoicingContact', type: 'tablisttable', item: 'office_inputfield_fic' },

  { role: 'FinanceAdmin', type: 'inputfield', item: 'FinanceAdmin_inputfield' },
  { role: 'FinanceAdmin,OfficeOverhead', type: 'ButtonRowButton', item: 'createofficeoverheadbutton' },
  { role: 'FinanceAdmin,OfficeOverhead', type: 'faicon', item: 'office_overhead_remove' },
  { role: 'God', type: 'all', item: 'god' },
  { role: 'IOBEdit', type: 'ButtonRowButton', item: 'iob_createcreatelineitemmarkaspaidattachinvoicebutton' },
  { role: 'IOBEdit', type: 'faicon', item: 'iob_editfinalizemarkaspaidlineitemedit' },
  { role: 'IOBView', type: 'ButtonRowButton', item: 'iob_downloadinvoicebutton' },
  { role: 'IOBView', type: 'submenu', item: 'operations_iob' },
  { role: 'ClientEdit', type: 'ButtonRowButton', item: 'client_edit' },
  // The Client page's Pricing History tab (CD-5650): the same roles as ClientPricingHistoryController's [Authorize].
  {
    role: 'ClientView,ClientEdit,ClientCreateAdmin,KAMGuest,KAM,KAMAdmin,SalesAdmin,Sales,SalesGuest,OpportunityView',
    type: 'tablisttable',
    item: 'client_pricinghistory',
  },
  //{ role: 'ManualOwningOfficeFee', type: 'inputfield', item: 'manual_owningofficefee_inputfield' },
  { role: 'OfficeAdmin,OfficeAdminWrite,OfficeGeneralAdmin', type: 'submenu', item: 'home_general' },
  { role: 'OfficeAdmin,OfficeOverhead,FinanceAdmin,Finance', type: 'tablisttable', item: 'tablistable_officeoverhead' },
  { role: 'OfficeAdminWrite', type: 'tablisttable', item: 'home_offices_edit' },
  { role: 'OpportuinityExtendActualEndDate', type: 'faicon', item: 'Opportuinity_faicon_ExtendActualEndDate' },
  { role: 'OpportunityEdit', type: 'faicon,ButtonRowButton', item: 'opportunity_edit' },
  { role: 'OpportunityEdit', type: 'ButtonRowButton', item: 'sales_opportunities_button' },
  { role: 'OpportunityView', type: 'submenu', item: 'sales_pricingMain' },
  { role: 'OpportunityView', type: 'submenu', item: 'sales_opportunities' },
  { role: 'OpportunityAdmin', type: 'inputfield', item: 'opportunity_admin_role_key' },
  { role: 'PricingFeature,OpportunityView', type: 'tablisttable', item: 'PricingDataTable' },
  { role: 'PricingFeature,OpportunityView', type: 'tablisttable', item: 'PricingDataTable' },
  // Creating, editing, assigning and removing pricings (CD-5720): the same roles as PricingController's [Authorize]
  // on PostPricing and PricingMultipleAction (PricingEditRoles: Admin, OpportunityEdit).
  { role: 'OpportunityEdit', type: 'faicon,ButtonRowButton', item: 'pricing_edit' },
  { role: 'ProjectEdit', type: 'actionbutton,ButtonRowButton', item: 'project_addnewclientfee' },
  { role: 'ProjectEdit', type: 'ButtonRowButton', item: 'project_associatesurvey' },
  { role: 'ProjectEdit', type: 'faicon,actionbutton,ButtonRowButton,datatable', item: 'project_edit' },
  { role: 'ProjectEdit', type: 'faicon', item: 'project_removesurvey' },
  { role: 'RunPlatformCost', type: 'ButtonRowButton', item: 'run_platform_cost' },
  { role: 'ProjectEdit,ClientEdit', type: 'ButtonRowButton', item: 'assignment_edit' },
  { role: 'AssignmentEdit', type: 'faicon', item: 'assignment_edit' },
  { role: 'ProjectEdit,ClientEdit', type: 'datatable', item: 'project_excludedassignmentselect' },
  { role: 'ProjectEdit,ClientEdit', type: 'datatable', item: 'project_finalizedassignmentselect' },
  { role: 'ProjectEdit,ClientEdit', type: 'datatable', item: 'project_uninvoiceableassignmentselect' },
  { role: 'ProjectView', type: 'submenu', item: 'operations_projects' },
  { role: 'ProjectView', type: 'faicon', item: 'project_viewdetail' },
  { role: 'Report_ReferralShopExport', type: 'ButtonRowButton', item: 'report_referralshopexport_run' },
  { role: 'RoverImportUser', type: 'menu,submenu', item: 'apolloapijobimport' },
  // Survey Transfer Mapping: only this role (besides Admin/Developer) may see/handle the pages.
  // It needs the parent "Apollo API JobImport" menu plus the dedicated item below.
  { role: 'SurveyTransferMapping', type: 'menu', item: 'apolloapijobimport' },
  { role: 'SurveyTransferMapping', type: 'menu,submenu,ButtonRowButton,faicon,actionbutton,tablisttable,detailBox,inputfield', item: 'surveytransfermapping' },
  { role: 'Sales,SalesAdmin', type: 'submenu,ButtonRowButton,faicon', item: 'sales_leads' },
  { role: 'Sales,SalesAdmin,OpportunityView', type: 'menu,submenu', item: 'pricingitem_details' },
  { role: 'Sales,SalesAdmin,OpportunityView', type: 'menu,submenu', item: 'service_details' },
  {
    role: 'Sales,SalesAdmin,KAM,KAMAdmin',
    type: 'actionbutton,ButtonRowButton',
    item: 'ClientContact_ActionButton_CreateEdit',
  },
  {
    role: 'Sales,SalesAdmin,KAM,KAMAdmin,ClientEdit',
    type: 'ButtonRowButton,faicon',
    item: 'AddressAdmin_CreateAddress',
  },
  {
    role: 'Sales,SalesAdmin,KAM,KAMAdmin,ClientEdit,KAM,KAMAdmin',
    type: 'faicon',
    item: 'ClientContact_faicon_CreateEdit',
  },
  { role: 'Sales,SalesAdmin,KAMGuest,KAM,KAMAdmin', type: 'link', item: 'location_link' },
  { role: 'SalesAdmin', type: 'actionbutton', item: 'Client_actionButton_Create' },
  // CD-5220: the vendor-cost switch on the Edit User panel. Narrower than the panel itself
  // (UserAdmin can edit the user but not this field); Admin/Developer bypass as usual.
  { role: 'SalesAdmin', type: 'inputfield', item: 'useradmin_IncludeVendorCostInCostCalculation' },
  { role: 'SalesGuest,Sales,SalesAdmin', type: 'ButtonRowButton', item: 'lead_newlead_button' },
  { role: 'TimesheetAdmin', type: 'submenu', item: 'timesheet_managetasks' },
  // Bridge Day Calendar: HR (and Admin/Developer, which bypass) may see and open the admin page.
  { role: 'HR', type: 'submenu', item: 'officecalendar_key' },
  { role: 'TipaltiCsvDownload', type: 'ButtonRowButton', item: 'tipaltidownloadbutton' },
  { role: 'User', type: 'menu,submenu,ButtonRowButton', item: 'user_key' },
  { role: 'InvoiceView,InvoiceEdit', type: 'submenu', item: 'operations_invoices_admin' },
  { role: 'Admin,InvoiceView,InvoiceEdit', type: 'faicon', item: 'clientInvoice_link' },
  { role: 'Admin,InvoiceView,InvoiceEdit', type: 'submenu', item: 'operations_invoices' },
  { role: 'Admin,InvoiceEdit', type: 'faicon', item: 'edit_invoice' },
  { role: 'Admin,InvoiceEdit', type: 'faicon', item: 'cancel_invoice' },
  { role: 'Admin,InvoiceEdit', type: 'faicon', item: 'finalize_invoice' },
  { role: 'Admin,InvoiceEdit', type: 'faicon', item: 'create_creditmemo' },
  { role: 'Admin,InvoiceEdit', type: 'faicon', item: 'clientInvoice_Create' },
  { role: 'UserOfficeChange', type: 'buttonWithIcon', item: 'user_office_change' },
  { role: 'Admin,InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_finalizeselected' },
  { role: 'Admin,InvoiceBulkFinalization', type: 'ButtonRowButton', item: 'clientinvoice_invoicebulkfinalize' },
  { role: 'Admin,InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_removelineitem' },
  { role: 'Admin,InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_updatemultiplerecords' },
  { role: 'Admin,InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_newlineitem' },
  { role: 'Admin,InvoiceEdit', type: 'faicon', item: 'edit_invoicelineitem' },
  { role: 'Reports_SAPReconciliationExport', type: 'ButtonRowButton', item: 'report_sapreconciliation_run' },
  { role: 'Report_QBO_Export', type: 'ButtonRowButton', item: 'report_qboinvoice_run' },
  { role: 'Report_QBO_Export', type: 'ButtonRowButton', item: 'report_qbocreditmemo_run' },
  // PlatformInvoiceView is listed because TP Platform Invoices lives under Finance: the
  // sidebar drops a whole section when the user lacks the section key, so without it a
  // platform-invoice user would see no Finance group and lose the page from the nav.
  {
    role: 'Admin,ClientPaymentView,ClientPaymentEdit,OutsourcedFteView,OutsourcedFteEdit,PlatformInvoiceView',
    type: 'menu',
    item: 'finance',
  },
  { role: 'Admin,ClientPaymentView,ClientPaymentEdit', type: 'submenu', item: 'finance_clientpayment' },
  { role: 'Admin,ClientPaymentView,ClientPaymentEdit', type: 'submenu', item: 'new_finance_clientpayment' },
  { role: 'ClientPaymentView,ClientPaymentEdit', type: 'faicon', item: 'clientPayment_link' },
  { role: 'ClientPaymentView,ClientPaymentEdit', type: 'submenu', item: 'clientpaymentdetails' },
  { role: 'Admin, ClientPaymentView,ClientPaymentEdit', type: 'submenu', item: 'new_clientpaymentdetails' },
  { role: 'Admin,InvoiceView,CreditMemoView', type: 'faicon', item: 'creditmemorequest_link' },
  { role: 'Admin,InvoiceView,CreditMemoView', type: 'faicon', item: 'creditmemo_link' },
  { role: 'Admin', type: 'ButtonRowButton', item: 'clientpayment_apply' },
  { role: 'Admin', type: 'ButtonRowButton', item: 'clientpayment_remove' },
  { role: 'ClientPaymentView,ClientPaymentEdit', type: 'submenu', item: 'clientprepaymentdetails' },
  { role: 'Admin', type: 'ButtonRowButton,faicon', item: 'clientpayment_create' },
  { role: 'Admin', type: 'faicon', item: 'clientpayment_refund' },
  { role: 'Admin', type: 'faicon', item: 'clientpayment_reverse' },

  { role: 'Admin,InvoiceEdit,ClientPaymentEdit', type: 'ButtonRowButton', item: 'tp_clientpayment_apply' },
  { role: 'Admin,InvoiceEdit,ClientPaymentEdit', type: 'ButtonRowButton', item: 'tp_clientpayment_remove' },
  { role: 'Admin,ClientPaymentEdit', type: 'ButtonRowButton,faicon', item: 'tp_clientpayment_create' },
  { role: 'Admin,ClientPaymentEdit', type: 'faicon', item: 'tp_clientpayment_refund' },
  { role: 'Admin,ClientPaymentEdit', type: 'faicon', item: 'tp_clientpayment_reverse' },

  {
    role: 'Admin,Reports_ExcelDataReportsGlobal,Reports_ExcelDataReportsOffice',
    type: 'ButtonRowButton',
    item: 'exceldataexport',
  },
  {
    role: 'Admin,Reports_ExcelDataReportsGlobal',
    type: 'inputfield',
    item: 'exceldataexport_office_input',
  },
  { role: 'InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_attachpdfbutton' },
  { role: 'InvoiceView,InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_excelwordbutton' },
  { role: 'CreditMemoEdit', type: 'ButtonRowButton', item: 'creditmemo_attachpdfbutton' },
  { role: 'CreditMemoView,CreditMemoEdit', type: 'ButtonRowButton', item: 'creditmemo_excelwordbutton' },

  { role: 'Reports_PricingExport', type: 'faicon,ButtonRowButton', item: 'reports_pricingexport' },
  { role: 'Reports_OpportunityExport', type: 'ButtonRowButton', item: 'reports_opportunityexport' },
  { role: 'Reports_LeadExport', type: 'ButtonRowButton', item: 'reports_leadexport' },
  { role: 'Reports_ClientExport', type: 'ButtonRowButton', item: 'reports_clientexport' },

  { role: 'Report_EvaluatorPersonaExport', type: 'ButtonRowButton', item: 'persona_export_button' },
  { role: 'Report_EvaluatorPersonaExport', type: 'tabbedPageTab', item: 'persona_export_tab' },
  { role: 'Report_EmailCampaignExport', type: 'ButtonRowButton', item: 'email_campaign_export_button' },
  {
    role: 'Report_EmailCampaignExportAdmin',
    type: 'inputfield',
    item: 'email_campaign_specialinputfield',
  },
  {
    role: 'Report_EmailCampaignExportAdmin_EmailOptOut',
    type: 'inputfield',
    item: 'email_campaign_emailoptout_inputfield',
  },
  {
    role: 'Report_EmailCampaignExport,Report_EmailCampaignExportAdmin,Report_EmailCampaignExportAdmin_EmailOptOut',
    type: 'tabbedPageTab',
    item: 'email_campaign_export_tab',
  },
  { role: 'Report_EvaluatorTextMessageExport', type: 'ButtonRowButton', item: 'text_message_export_button' },
  {
    role: 'Report_EvaluatorTextMessageExportAdmin',
    type: 'inputfield',
    item: 'text_message_specialinputfield',
  },
  {
    role: 'Report_EvaluatorTextMessageExport,Report_EvaluatorTextMessageExportAdmin',
    type: 'tabbedPageTab',
    item: 'text_message_export_tab',
  },
  { role: 'Report_EvaluatorSchedulingReport_Export', type: 'ButtonRowButton', item: 'scheduling_export_button' },
  { role: 'Report_EvaluatorSchedulingExport', type: 'tabbedPageTab', item: 'scheduling_export_tab' },
  { role: 'EvaluatorGlobalView', type: 'inputfield', item: 'evaulator_inputfield_EvaluatorGlobalView' },
  // { role: 'User', type: 'ButtonRowButton,faicon', item: 'editcxaccounts' },
  { role: 'User', type: 'ButtonRowButton,faicon', item: 'edit_cxbaremanager' },
  { role: 'ClientGeneralLevelView', type: 'tablisttable', item: 'clientgenerallevel_tablisttable' },
  { role: 'ClientGeneralLevelEdit', type: 'ButtonRowButton,faicon', item: 'clientgenerallevel_editbutton' },
  { role: 'ClientGeneralLevelCxRoleLinkView', type: 'tablisttable', item: 'clientgenerallevelcxrolelink_tablisttable' },
  {
    role: 'ClientGeneralLevelCxRoleLinkEdit',
    type: 'ButtonRowButton,faicon',
    item: 'clientgenerallevelcxrolelink_editbutton',
  },
  { role: 'GroupClientManagerLinkView', type: 'tablisttable', item: 'groupclientmanagerlink_tablisttable' },
  { role: 'GroupClientManagerLinkEdit', type: 'ButtonRowButton,faicon', item: 'groupclientmanagerlink_editbutton' },
  { role: 'InvoiceEdit', type: 'ButtonRowButton', item: 'clientinvoice_excelreport' },
  { role: 'Admin,ProjectEdit', type: 'ButtonRowButton', item: 'reports_tpjobs' },
  // Testing menu (CD-5529): BITestPage is the general-access role for every page in it.
  // DomoIFrameView opens the Domo page and, since CD-5566, the BI Test Reports page too.
  { role: 'DomoIFrameView,BITestPage', type: 'menu,submenu', item: 'testingkey' },
  { role: 'DomoIFrameView,BITestPage', type: 'submenu', item: 'bitestreports' },
  { role: 'ProjectView', type: 'menu,submenu', item: 'new_projects' },
  { role: 'ClientView,AssignmentView', type: 'menu,submenu', item: 'operations_thirdpartyjobs' },
  { role: 'TPExportExcludedItemsView', type: 'menu,submenu', item: 'operations_thirdpartydataexportexcludeditems' },
  { role: 'TPImportExcludedItemsView', type: 'menu,submenu', item: 'operations_thirdpartydataimportexcludeditems' },
  { role: 'PlatformInvoiceView', type: 'menu,submenu', item: 'operations_tpplatforminvoices' },
  { role: 'PlatformInvoiceEdit', type: 'faicon', item: 'platforminvoice_setbillingperiod' },
  { role: 'Admin', type: 'special_case', item: 'commissionrate_statusoverride' },
  { role: 'InvoiceView,InvoiceEdit', type: 'submenu,faicon,ButtonRowButton', item: 'tpclientinvoices_view' },
  { role: 'InvoiceEdit,ProjectEdit,ClientEdit', type: 'faicon', item: 'tpclientinvoices_create' },
  { role: 'InvoiceEdit', type: 'faicon,ButtonRowButton', item: 'tpclientinvoices_edit' },
  { role: 'InvoiceBulkFinalization', type: 'ButtonRowButton', item: 'tpclientinvoices_bulkfinalize' },
  { role: 'InvoiceEdit', type: 'ButtonRowButton', item: 'tpclientinvoices_manualevaluatoriob' },
  { role: 'BE_Finance_XML_Conversion', type: 'ButtonRowButton', item: 'BE_Finance_XML_Conversion' },
  { role: 'ShopperPaymentRecon', type: 'ButtonRowButton', item: 'PaymentInformationValidation_ButtonRowButton' },
  { role: 'ShopperPaymentRecon', type: 'ButtonRowButton', item: 'RequestPaymentDetailsReview_ButtonRowButton' },

  {
    role: 'CreditMemoView,CreditMemoEdit,CreditMemoAssigneeChange,OfficeAdmin',
    type: 'submenu,ButtonRowButton,faicon,tabbedPageTab',
    item: 'tpcreditmemos_view',
  }, //operations_creditmemos, creditmemo_excelwordbutton
  { role: 'Admin', type: 'submenu', item: 'operations_tpevaluatortpjobpayments' },
  { role: 'CreditMemoEdit', type: 'faicon,ButtonRowButton', item: 'tpcreditmemo_createandmodifycredit' }, //creditmemo_editbuttonrowbutton, creditmemo_attachpdfbutton
  { role: 'CreditMemoEdit,OfficeAdmin', type: 'faicon', item: 'tpcreditmemo_editandstatuschange' }, //creditmemo_editfaicon
  { role: 'CreditMemoAssigneeChange', type: 'inputfield', item: 'tpcreditmemo_editassignee' }, //creditmemo_editassignee
  { role: 'OpenAiUser', type: 'menu,submenu', item: 'tools_key' },
  { role: 'OpenAiUser', type: 'menu,submenu', item: 'ai_chat' },
  { role: 'CommissionOverride', type: 'inputfield', item: 'commission_override' },
  { role: 'ExcelDataReportsARAgeing', type: 'ButtonRowButton', item: 'report_arageingreport_run' },
  { role: 'Reports_ExcelDataReportsGlobal,Reports_ExcelDataReportsOffice', type: 'ButtonRowButton', item: 'report_unappliedprepayment_run' },
  { role: 'Admin,EvaluatorCount_ExcelReport', type: 'ButtonRowButton', item: 'report_evaluatorcountreport_run' },

  { role: 'EOMSetup', type: 'ButtonRowButton,faicon', item: 'eom_setup' },
  { role: 'User', type: 'menu,submenu', item: 'end_of_month' },
  { role: 'EOMSetup', type: 'inputfield', item: 'officegeneral_editeomautomation' },
  { role: 'Admin,Reports_ExcelDataReportsGlobal,Reports_ExcelDataReportsOffice', type: 'ButtonRowButton', item: 'report_evaluatorpaymentsexport_run' },
  { role: 'Admin', type: 'ButtonRowButton', item: 'report_evaluatorpaymentsexport_run' },
  { role: 'Admin,Reports_ExcelDataReportsGlobal,Reports_ExcelDataReportsOffice', type: 'ButtonRowButton', item: 'report_tprevenuebyrevenueperiod_run' },
  { role: 'Admin', type: 'faicon', item: 'anonymize_evaluator_lead' },
  { role: 'Admin,Reports_EvaluatorLead', type: 'ButtonRowButton', item: 'report_evaluatorleadreport_run' },
  { role: 'Admin,ClientPOCExport', type: 'ButtonRowButton', item: 'report_clientpocexport_run' },
  { role: 'Admin,OpportunityPOCExport', type: 'ButtonRowButton', item: 'report_opportunitypocexport_run' },
  { role: 'Admin', type: 'ButtonRowButton,faicon', item: 'group_edit' },

  { role: 'Admin,UserAdmin', type: 'menu,submenu', item: 'user_groups' },
  { role: 'Admin,Shopcount', type: 'submenu', item: 'reports_shopcountreport' },
  { role: 'Admin,OpsPBIDashboard', type: 'submenu', item: 'reports_opspbidashboard' },
  { role: 'Admin,DQTATReport', type: 'submenu', item: 'reports_dqtatreport' },

  { role: 'VendorInvoicingAdmin_Reporting', type: 'submenu,link', item: 'vendor_dashboard' },
  { role: 'ClientView,KAM,KAMAdmin,KAMGuest,Sales,SalesAdmin', type: 'submenu,menu', item: 'operations_tplocation' },
  // Same gate as the endpoint behind it: TpClientLinkController.GetItems allows Admin,ClientView
  // (Admin and Developer bypass every rule in RoleService, so only ClientView is listed here). The
  // embedded Third-Party Clients tab on a client calls that same endpoint on the same role, so keep
  // the two in step — restricting this page must not narrow the endpoint, which took the tab away
  // from every ClientView user once already (CD-5543).
  { role: 'ClientView', type: 'submenu,menu', item: 'operations_tpclientlink' },
  { role: 'ClientEdit', type: 'faicon', item: 'tpclientlink_unlink' },
  { role: 'EvaluatorListView,EvaluatorGeneralView', type: 'submenu,menu', item: 'operations_thirdpartyevaluator' },
  { role: 'Admin', type: 'submenu,menu', item: 'JustAdmins' },

  // Outsourced Employee FTE
  { role: 'OutsourcedFteView,OutsourcedFteEdit', type: 'submenu', item: 'outsourcedfte_view' },
  { role: 'OutsourcedFteEdit', type: 'ButtonRowButton,faicon', item: 'outsourcedfte_edit' },
  { role: 'OutsourcedFteLock', type: 'ButtonRowButton,faicon', item: 'outsourcedfte_lock' },
  { role: 'OutsourcedFteIobGenerate', type: 'ButtonRowButton', item: 'outsourcedfte_iobgenerate' },
  { role: 'OutsourcedFteIobReverse', type: 'ButtonRowButton,faicon', item: 'outsourcedfte_iobreverse' },
  { role: 'OutsourcedFteView,OutsourcedFteEdit', type: 'tablisttable', item: 'outsourcedfte_usertab' },

  // Permission defined by a custom function

  // Allows edit timesheetentry function if the given user has a timesheetuser record
  { role: (actualUser) => !!actualUser.timesheetUser, type: 'function', item: 'timesheetEntry', action: 'write' },
];

export default rules;
